import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import ExcludedUserAgents from './ExcludedUserAgents';

export type TagsInputValue = any[]

const mapStateToProps = (state: any, { t }: { t: any }) => {
  const excludedUserAgents: TagsInputValue = state.trackerSettings.app.settings
    .attributes.excluded_user_agents || [];
  const globalExcludedUserAgents: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.excluded_user_agents || []
  )
    .map(
      (element: any) => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalExcludedUserAgents,
    ...excludedUserAgents,
  ];

  return {
    globalAndAppTrackerSettings,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(ExcludedUserAgents));
